<template>
  <div class="worksAudit">
    <childLogo></childLogo>
    <div class="navbar-dark">
      <div class="container">
        <div class="sigma-content">
          <div class="sigma-middle-line">
            <span class="sigma-line-text">作品审核</span>
          </div>
        </div>
        <div style="font-size: 22px;margin: 15px;color: #5e5e5e;">中国国际科普作品大赛</div>
        <div>
          <el-steps :active="2" align-center>
            <el-step title="用户报名" description="2020-07-01"></el-step>
            <el-step title="作品申报" description="2020-08-01"></el-step>
            <el-step title="作品初审" description="2020-09-01"></el-step>
            <el-step title="作品终审" description="2020-10-01"></el-step>
            <el-step title="获奖公布" description="2020-11-01"></el-step>
          </el-steps>
          <el-tabs
            v-model="activeName"
            type="card"
            @tab-click="handleClick"
            style="margin-top: 60px;"
          >
            <el-tab-pane label="用户管理" name="first">
              <el-table
                :data="tableData"
                stripe
                style="width: 100%;"
                :header-cell-style="{background:'#1890ff',color: '#fff',textAlign: 'center'}"
                align="center"
              >
                <el-table-column type="selection" width="50"></el-table-column>
                <el-table-column prop="date" label="序号" width="60"></el-table-column>
                <el-table-column prop="name" label="作品名称"></el-table-column>
                <el-table-column prop="address" label="提交时间" width="120"></el-table-column>
                <el-table-column prop="address" label="总分" width="100"></el-table-column>
                <el-table-column prop="address" label="操作" width="300"></el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>
            <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
            <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChildLogo from "@/components/ChildLogo.vue";
export default {
  components: {
    ChildLogo: ChildLogo
  },
  data() {
    return {
      activeName: "first",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄"
        }
      ]
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<style scoped>
.expertName {
  display: inline-block;
  text-align: left;
  width: 50%;
  color: #0c70fc;
  font-size: 36px;
  padding-left: 20px;
}

.introduction {
  text-align: left;
  padding: 20px;
  text-indent: 2em;
}

.sigma-content {
  margin: 40px 0 10px;
  text-align: center;
  background-color: #fff;
}
.sigma-middle-line:before {
  content: "";
  display: block;
  height: 1px;
  width: 100%;
  background-color: #0c70fc; /*颜色需与bai主题大背景du色一致zhi*/
  position: relative;
  top: 25px; /*调节线高*/
  left: 0;
}
.sigma-line-text {
  display: inline-block;
  background: #fff;
  padding: 0 18px 0 18px;
  position: relative;
  font-size: 28px;
  font-weight: 500;
  color: #0c70fc;
}

.firstLevel {
  text-align: left;
  font-weight: bold;
}
</style>

<style>
.worksAudit .el-tabs__header {
  margin: 0;
}

.worksAudit .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #eff6ff;
}

.worksAudit .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #dbebff;
  color: #3684f1;
}

.worksAudit .el-tabs__item.is-active {
  color: #ffffff !important;
  background: #2591f4 !important;
  border: 1px solid #2591f4 !important;
}

.worksAudit .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

.worksAudit .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}

.worksAudit .el-tabs--card > .el-tabs__header .el-tabs__item {
  width: 180px;
  border-radius: 6px 6px 0 0;
  height: 45px;
  line-height: 45px;
  color: #0c70fc;
  background: #f4f4f4;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/views/WorksAudit.vue